import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Router } from '@angular/router';
import { EventListStore } from '../../service/event-list.store';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { MenuStore } from '../../../menus/service/menu.store';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { PaymentStatusUtils } from '../../utils/payment-status-utils';
import { PaymentStatus } from '../../models/payment-status.enum';

@Component({
  selector: 'pioneer-event-list-financial-table',
  templateUrl: './event-list-financial.component.html'
})
export class EventListFinancialComponent implements OnInit {

  private data: Observable<List<OnyxSummaryEvent>>;

  public searchText: string;

  constructor(private eventListStore: EventListStore,
              private environment: EnvironmentConfiguration,
              private router: Router,
              private menuStore: MenuStore) {
  }

  ngOnInit() {
    this.data = this.eventListStore.events;
    this.menuStore.setPageTitle('EVENTS.TITLE');
    this.searchText = '';
  }

  get events(): Observable<List<OnyxSummaryEvent>> {
    return this.data;
  }

  get eventCount(): Observable<number> {
    return this.eventListStore.totalEventCount;
  }

  get eventCountForTranslate(): Observable<Object> {
    return this.eventCount.map(count => {
      return {
        eventCount: count
      };
    });
  }

  get eventsAboveMax(): Observable<boolean> {
    return this.eventCount.map(eventCount => {
      return eventCount > this.maxEvents;
    });
  }

  get eventsPresent(): Observable<boolean> {
    return this.eventCount.map(eventCount => {
      return eventCount > 0;
    });
  }

  get maxEvents(): number {
    return this.environment.events.maxEvents;
  }

  get maxEventsForTranslate(): Object {
    return {
      maxEvents: this.maxEvents
    };
  }

  getPaymentAmount(eventSummary: OnyxSummaryEvent): number {
    if (PaymentStatusUtils.isError(<any>eventSummary.payStatus)) {
      return 0;
    } else {
      return Number(eventSummary.paymentAmount);
    }
  }

  getEstimatedDue(eventSummary: OnyxSummaryEvent): number {
    let estimatedDue = Number(eventSummary.dueAmount);
    estimatedDue = Math.max(estimatedDue, 0);
    estimatedDue = Math.round(estimatedDue);
    return estimatedDue;
  }

  onSelect(event: OnyxSummaryEvent): void {
    this.router.navigate([ '/event', event.eventId ]);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.ts